import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAppStore } from '@/popup/store/AppStore'
import NetworkSwitchModal from '@/popup/components/Modal/NetworkSwitch.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkSwitchWrapper',
  setup(__props) {

const appStore = useAppStore()

return (_ctx: any,_cache: any) => {
  const _component_ModalTransition = _resolveComponent("ModalTransition")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_ModalTransition, null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(NetworkSwitchModal, {
          "selected-network": _unref(appStore).state.networkModalName
        }, null, 8 /* PROPS */, ["selected-network"]), [
          [_vShow, _unref(appStore).state.showNetworkModal]
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})